exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pricing-rate {\n  margin-top: 2rem;\n  padding: 4px 0rem;\n  border-radius: 4px;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #6c7c8a;\n}\n\n.pricing-rate .pricing-rate_rate {\n  color: red;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Pricing/NewPricing/step-review.style.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/resolve-url-loader/index.js!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Pricing/NewPricing/step-review.style.scss
// module chunks = 0